if (!Set.prototype.difference) {
    Set.prototype.difference = function <T>(this: Set<T>, other: Set<T>) {
        const result = new Set<T>()
        for (const key of this.keys()) {
            if (!other.has(key)) {
                result.add(key)
            }
        }
        return result
    }
}

if (!Set.prototype.intersection) {
    Set.prototype.intersection = function <T>(this: Set<T>, other: Set<T>) {
        const result = new Set<T>()

        if (this.size > other.size) {
            // All items of `b` that also exist in `a`
            for (const key of other.keys()) {
                if (this.has(key)) {
                    result.add(key)
                }
            }
        } else {
            // All items of `b` that also exist in `a`
            for (const key of this.keys()) {
                if (other.has(key)) {
                    result.add(key)
                }
            }
        }

        return result
    }
}

if (!Set.prototype.symmetricDifference) {
    Set.prototype.symmetricDifference = function <T>(this: Set<T>, other: Set<T>) {
        const result = new Set<T>()

        // All items of `a` that do not exist in `b`
        for (const key of this.keys()) {
            if (!other.has(key)) {
                result.add(key)
            }
        }

        // All items of `b` that do not exist in `a`
        for (const key of other.keys()) {
            if (!this.has(key)) {
                result.add(key)
            }
        }

        return result
    }
}
